"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.periodToSeconds = void 0;
const enum_1 = require("../enum");
const dayjs_1 = __importDefault(require("./utils/dayjs"));
const periodToSeconds = (period) => {
    const secondsPerMin = 60;
    switch (period) {
        case enum_1.EChartPeriod.MINUTE_2:
            return secondsPerMin * 2;
        case enum_1.EChartPeriod.MINUTE_3:
            return secondsPerMin * 3;
        case enum_1.EChartPeriod.MINUTE_4:
            return secondsPerMin * 4;
        case enum_1.EChartPeriod.MINUTE_5:
            return secondsPerMin * 5;
        case enum_1.EChartPeriod.MINUTE_6:
            return secondsPerMin * 6;
        case enum_1.EChartPeriod.MINUTE_10:
            return secondsPerMin * 10;
        case enum_1.EChartPeriod.MINUTE_15:
            return secondsPerMin * 15;
        case enum_1.EChartPeriod.MINUTE_20:
            return secondsPerMin * 20;
        case enum_1.EChartPeriod.MINUTE_30:
            return secondsPerMin * 30;
        case enum_1.EChartPeriod.HOUR_1:
            return secondsPerMin * 60;
        case enum_1.EChartPeriod.HOUR_2:
            return secondsPerMin * 120;
        case enum_1.EChartPeriod.HOUR_3:
            return secondsPerMin * 180;
        case enum_1.EChartPeriod.HOUR_4:
            return secondsPerMin * 240;
        case enum_1.EChartPeriod.HOUR_6:
            return secondsPerMin * 360;
        case enum_1.EChartPeriod.DAY:
            return secondsPerMin * 1440;
        case enum_1.EChartPeriod.WEEK:
            return secondsPerMin * 1440 * 7;
        case enum_1.EChartPeriod.MONTH:
            return secondsPerMin * getMinutesFromMonth();
        default:
            return secondsPerMin;
    }
};
exports.periodToSeconds = periodToSeconds;
const getMinutesFromMonth = () => {
    const now = (0, dayjs_1.default)();
    const startOfMonth = now.startOf("month");
    const endOfMonth = now.endOf("month");
    const diff = endOfMonth.diff(startOfMonth);
    const totalMinutes = dayjs_1.default.duration(diff).asMinutes();
    return totalMinutes;
};
